import { useAtom, useSetAtom } from 'jotai';
import { loadable } from 'jotai/utils';
import { userPreferencesAtom } from '~/atoms/userPreferences';
import { useState } from 'react';
const loadingAtom = loadable(userPreferencesAtom);
export const useUserPreferences = () => {
    const [loadingState] = useAtom(loadingAtom);
    const setAtom = useSetAtom(userPreferencesAtom);
    const [isSaving, setIsSaving] = useState(false);
    const updateUserPreferences = async (update) => {
        setIsSaving(true);
        try {
            await setAtom(update);
        }
        finally {
            setIsSaving(false);
        }
    };
    return {
        userPreferences: loadingState.state === 'hasData' ? loadingState.data : undefined,
        userPreferencesLoadingState: loadingState.state,
        updateUserPreferences,
        isSaving
    };
};
